import { Caption, H3 } from '~/shared/Typography';
import { VStack, HStack, Box, Pressable } from 'native-base';
import { i18nFn, Plan } from '@springbig/shared';
import { useGeneralStyles } from '~/shared/styles';
import Button from '~/shared/Button';
import { useAppNavigate } from '~/pages';
import PlanBenefits from '~/pages/subscriptions/components/PlanBenefits';
import { PlanSchedule } from '~/pages/subscriptions/components/PlanSchedule';
import React from 'react';

type PlanCardProps = {
    t: i18nFn;
    plan: Plan;
    status: 'active' | 'inactive';
};

const PlanCard = ({ plan, status, t }: PlanCardProps) => {

    const { navigate, params } = useAppNavigate();

    const { section_background } = useGeneralStyles();
    const gStyles = useGeneralStyles();

    const onClickPlan = (): void => {

        const id = plan.id.split('-').slice(1, -1).join('-');
        const idPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

        if (params.wallet_id && idPattern.test(id)) {
            navigate(`w/${params.wallet_id}/subscription/${id}`);
        }
    };

    return (
        <VStack
            bg={section_background}
            mx={2}
            py={plan.plan_description_type === 'bullet' ? 2 : 0}
            px={plan.plan_description_type === 'bullet' ? 4 : 0}
            space={2}
            borderRadius={10}
            borderWidth={plan.plan_description_type === 'bullet' ? 2 : 0}
            borderColor={status === 'active' ? gStyles.button_background : 'transparent'}
        >
            { plan.plan_description_type === 'bullet' &&
                <H3
                    color={gStyles.button_background}
                    alignSelf={'center'}
                    textAlign={'center'}
                    fontSize={24}
                >
                    { plan.name }
                </H3>
            }

            { plan.plan_description_type === 'image' ?

                <Pressable
                    onPress={onClickPlan}
                >
                    <img src={plan?.plan_description_image?.thumbnailSrc} width={'100%'} loading='lazy' />
                </Pressable>
                :

                <HStack justifyContent={'space-between'} space={2}>

                    <PlanBenefits plan={plan} />

                    <Button
                        bg={gStyles.button_background}
                        h={10}
                        alignSelf={'center'}
                        onPress={onClickPlan}
                    >
                        { plan.subscription?.status === 'suspended' &&
                            <Box borderRadius={'100%'} h={3} w={3} position={'absolute'} bg={'red'} right={-16} top={-14} />
                        }
                        <Caption
                            color={gStyles.button_text}
                            text={status === 'active' ? 'subscriptions.enjoying' : 'subscriptions.get'}
                        />
                    </Button>
                </HStack>
            }

            { plan.plan_description_type === 'bullet' &&
                <PlanSchedule plan={plan} t={t} />
            }
        </VStack>
    );
};

export default PlanCard;
